import * as React from 'react';
import { IGridHeaderProps } from './IGridHeaderProps';
import { IGridHeaderState } from './IGridHeaderState';
import { ReactComponent as ArrowDown } from '../../assets/arrowDown.svg';
import { ReactComponent as ArrowUp } from '../../assets/arrowUp.svg';
import { ReactComponent as SortDownArrow } from '../../assets/sortDownArrow.svg';
import { ReactComponent as SortUpArrow } from '../../assets/sortUpArrow.svg';
import styles from '../TVoSimpleGrid.module.scss';
import { IContextMenu } from '../../models/IContextMenu';
import ContextMenuItem from './ContextMenuItem';
import { SortType } from '../../types/SortType';
import { contextMenuConfig } from '../../config';

export default class GridHeader extends React.Component<
  IGridHeaderProps,
  IGridHeaderState
> {
  constructor(props: IGridHeaderProps) {
    super(props);
    this.state = {
      contextMenu: [],
      dataSourceName: this.props.dataSourceName,
      columnKey: this.props.column.key,
      column: this.props.column,
      columnHeader: '',
      isArrowUp: false
    };
    this.dropDownMenuClick = this.dropDownMenuClick.bind(this);
  }

  private createCustomMenu() {
    let tempContextMenu: IContextMenu[] = [];

    if (
      this.props.column.enableSorting ||
      this.props.column.enableSorting === undefined
    ) {
      tempContextMenu.push({
        value: contextMenuConfig.sortUp,
        label: 'Sort ascending'
      });
      tempContextMenu.push({
        value: contextMenuConfig.sortDown,
        label: 'Sort descending'
      });
    }

    tempContextMenu.push({
      value: contextMenuConfig.groupBy,
      label: 'Group by ' + this.props.column.headerName,
      enableBottomDivider: true
    });
    //make context menu exists
    if (this.props.column.contextMenu !== undefined) {
      var contextMenu = this.props.column.contextMenu;
      for (var i = 0; i < contextMenu.length; i++) {
        tempContextMenu.push({
          value: contextMenu[i].value,
          label: contextMenu[i].label,
          enableOnContextMenuRender: contextMenu[i].enableOnContextMenuRender,
          enableBottomDivider: contextMenu[i].enableBottomDivider
        });
      }
    }

    const columnHeader =
      this.props.column.enableOnHeaderItemRender &&
      this.props.onHeaderItemRender !== undefined
        ? this.props.onHeaderItemRender(
            this.props.dataSourceName,
            this.props.column.key,
            this.props.column.fieldName,
            this.props.column.headerName
          )
        : this.props.column.headerName;

    this.setState({
      contextMenu: tempContextMenu,
      dataSourceName: this.props.dataSourceName,
      columnKey: this.props.column.key,
      column: this.props.column,
      columnHeader: columnHeader
    });
  }
  public componentDidMount() {
    this.createCustomMenu();
  }

  public componentDidUpdate(prevProps: IGridHeaderProps) {
    if (prevProps.column !== this.props.column) {
      this.createCustomMenu();
    }
    if (this.state.isArrowUp !== this.props.column.isArrowUp) {
      this.setState({ isArrowUp: this.props.column.isArrowUp });
    }
    if (prevProps.column.isArrowUp !== this.props.column.isArrowUp) {
      this.setState({ isArrowUp: this.props.column.isArrowUp });
    }
  }

  private dropDownMenuClick = (e: any) => {
    this.props.dropDownClick(this.state.columnKey);
  };

  public render() {
    return (
      <div className={styles.columnHeader}>
        <div className={styles.columnHeaderLabel} id='column-header-label'>
          <div>
            {this.props.column.sortDirection === SortType.down && (
              <SortDownArrow />
            )}
            {this.props.column.sortDirection === SortType.up && <SortUpArrow />}
          </div>

          <div onClick={this.dropDownMenuClick}>{this.state.columnHeader}</div>

          {(this.props.column.enableContextMenu === undefined ||
            this.props.column.enableContextMenu) &&
            this.state.contextMenu.length > 0 && (
              <div onClick={this.dropDownMenuClick}>
                {!this.state.isArrowUp && <ArrowDown id='arrow-down' />}
                {this.state.isArrowUp && <ArrowUp id='arrow-up' />}
              </div>
            )}
        </div>
        {this.state.isArrowUp &&
          this.state.contextMenu.length > 0 &&
          (this.props.column.enableContextMenu === undefined ||
            this.props.column.enableContextMenu) && (
            <ul className={styles.columnContextMenu} id='contextMenu'>
              {this.state.contextMenu.map((item: IContextMenu, i) => {
                return (
                  <ContextMenuItem
                    key={i}
                    onSorting={this.props.onSorting}
                    onGrouping={this.props.onGrouping}
                    column={this.state.column}
                    sortDirection={
                      this.props.column.sortDirection !== undefined
                        ? this.props.column.sortDirection
                        : SortType.none
                    }
                    dataSourceName={this.state.dataSourceName}
                    isGrouping={this.props.column.isGrouping}
                    contextMenu={item}
                    onContextMenuClick={this.props.onContextMenuClick}
                    onContextMenuRender={this.props.onContextMenuRender}
                  />
                );
              })}
            </ul>
          )}
      </div>
    );
  }
}
